import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { SnCurrentOrganization } from '@lib/auth';

/**
 * Route guard that gates access to LPR Sharing Management based on an org feature flag.
 */
@Injectable({
  providedIn: 'root',
})
export class ViLprSharingManagementFeatureGuard implements CanActivate {
  constructor(
    private readonly _router: Router,
    private readonly _currentOrganization: SnCurrentOrganization,
  ) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this._currentOrganization.settings?.lprSharingManagementEnabled) {
      this._router.navigateByUrl('plates/list');
      return false;
    }
    return true;
  }
}


